import React, { Component } from 'react';
import moment from 'moment';
import BasicClaim from './basicClaim';
import DailyEditCheckListReport from './dailyEditCheckList';
import IncomeReport from './incomeReport';
import OnlineDepositReport from './onlineDepositReport';
import RevenueReport from './revenueReport';
import TempEligibilityReport from './tempEligibilityReport';
import AccountBalSummaryReport from './accountBalSummaryReport';
import MonthlySchoolDepositReport from './monthlySchoolDepositReport';
import DailySchoolDepositReport from './dailySchoolDepositReport';
import MonthlyIncomeCashReport from './monthlyIncomeCashReport';
import CEPClaim from './cepClaim';
import CepDailyEditCheck from './cepDailyEditCheck';
import NotificationSystem from 'react-notification-system';
import DailySalesReport from './dailySales';
import MonthlyRevenueReport from './monthlyRevenueReport';
import ConsumptionPaymentReport from './consumption_paymentsReport';
import LowBalReport from './lowBalReport';
import SalesRevenueReport from './salesRevenueReport';
import BenefitsIssuanceReport from './benefitsIssuancelistReport';
import { getSchoolYearOptions } from '../../../server/utilDistrict';
const styles = {
    panStyle: {
        minHeight: '250px',
        backgroundImage: 'radial-gradient(circle, rgb(0 143 102 / 10%), rgb(226 198 196 / 42%), #fbf1f114)'
    }
}
// School year is stored as the starting year (e.g. 2026 => "2026-27").
const formatSchoolYear = (y) => `${y}-${(y + 1).toString().slice(-2)}`;
// Reports rendered on the dashboard, in display order.
const REPORT_COMPONENTS = [
    RevenueReport,
    BasicClaim,
    CEPClaim,
    IncomeReport,
    DailyEditCheckListReport,
    CepDailyEditCheck,
    OnlineDepositReport,
    TempEligibilityReport,
    AccountBalSummaryReport,
    MonthlySchoolDepositReport,
    DailySchoolDepositReport,
    MonthlyIncomeCashReport,
    DailySalesReport,
    MonthlyRevenueReport,
    ConsumptionPaymentReport,
    LowBalReport,
    SalesRevenueReport,
    BenefitsIssuanceReport,
];

class Reports extends Component {
    constructor(props) {
        super(props);
        const schoolYearOptions = getSchoolYearOptions();
        const activeSchoolYear = schoolYearOptions[0];
        this.state = {
            activeSchoolYear,
            selectedSchoolYear: activeSchoolYear,
            schoolYearOptions,
        };
    };
    componentWillMount = () => {
        this.props.changeShowHideSchoolFitler(true);
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    render() {
        const { selectSchool } = this.props;
        const { activeSchoolYear, selectedSchoolYear, schoolYearOptions } = this.state;
        // Start date pickers in the selected school year's calendar by shifting
        // today back by the difference between the active and selected years.
        const reportDefaultDate = moment().subtract(activeSchoolYear - selectedSchoolYear, 'years').toDate();
        return (
            <div>
                <section>
                    <NotificationSystem ref="notificationSystem" />
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <span>Reports</span>
                            </h2>
                        </div>
                        <div className='row' style={{ marginBottom: '15px' }}>
                            <div className='col-sm-12 col-md-4 col-lg-3'>
                                <label className='control-label'>School Year</label>
                                <select className='form-control form-control-sm'
                                    value={selectedSchoolYear}
                                    onChange={(e) => {
                                        this.setState({ selectedSchoolYear: parseInt(e.target.value) });
                                    }}>
                                    {schoolYearOptions.map((y) => (
                                        <option key={y} value={y}>{formatSchoolYear(y)}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='row' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {REPORT_COMPONENTS.map((ReportComponent, i) => (
                                <div className='col-sm-12 col-md-4 col-lg-3' key={i}>
                                    <ReportComponent
                                        key={`report-${i}-${selectedSchoolYear}`}
                                        {...this.props}
                                        {...this}
                                        selectedSchoolYear={selectedSchoolYear}
                                        reportDefaultDate={reportDefaultDate}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Reports;



// WEBPACK FOOTER //
// ./src/components/District/Reports/index.js